import KlimtRadioButton, { RadioButtonProps } from '@eversports/klimt-primitives/legacy/RadioButton'

export type { RadioButtonProps }

const RadioButton = ({ ...props }: RadioButtonProps) => {
  return <KlimtRadioButton {...props} />
}

export default RadioButton
